import { React, useEffect, useState } from 'react';
import { Row, Col, Button, Modal, Space, message, DatePicker, Form, Tag, Popconfirm } from 'antd';
import { ExclamationCircleOutlined, HeartOutlined, PlusOutlined } from '@ant-design/icons';
import axios from "axios";
import NewTable from '../../NewTable';
import dayjs from 'dayjs';
import { Navigate, Outlet, useNavigate, useLocation, useParams } from 'react-router-dom'
import BillPaymentClassModal from './BillPaymentClassModal';
import { useBillPaymentClass } from '../controller/BillPaymentClassController';
import AddTuitionModal from '../../AddTuitionModal';

const { confirm } = Modal;

const BillPaymentClassOverview = () => {
    const navigate = useNavigate();
    const [total, set_total] = useState(1);
    const [extra_columns, set_extra_columns] = useState(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loading, set_loading] = useState(0);
    const [force_reload, set_force_reload] = useState(0)
    const [force_reset, set_force_reset] = useState(0)
    const [title, setTitle] = useState();
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [editcard, setEditCard] = useState({});
    const [color, setColor] = useState('d65b77');
    const [messageApi, contextHolder] = message.useMessage();
    const [datas, setDatas] = useState([])
    const [default_column, set_default_column] = useState([
        {
            title: '編號',
            key: 'name_serial',
            dataIndex: 'name_serial',
            align: 'center',
            sorter: false,
        },
        {
            title: '班級',
            key: 'name',
            dataIndex: 'name',
            sorter: false,
            align: 'center',
        },
        {
            title: '課程',
            key: 'lesson_name_arr',
            dataIndex: 'lesson_class_data',
            align: 'center',
            sorter: false,
            render: (text, record, index) => {
                return <Space >
                    {
                        text.map((value) => {
                            return value?.lesson_name
                        })
                    }

                </Space>
            }
        },
        {
            title: '授課老師',
            key: 'teacher_name_arr',
            dataIndex: 'teacher_data',
            align: 'center',
            sorter: false,
            render: (text, record, index) => {
                return <Space>
                    {text.map((value) => {
                        return <Tag color='gold'>{value?.teacher_name ?? "-"}</Tag>
                    })}
                </Space>
            }
        },
        {
            title: '授課時間',
            key: 'week_time_data',
            dataIndex: 'week_time_data',
            align: 'center',
            sorter: false,
            disabled: true,
            render: (text, record, index) => {
                return <Space direction="vertical">
                    {text.map((value) => {
                        return <Tag color="geekblue">
                            星期{value.week_name} {value?.time_start}-{value?.time_end}
                        </Tag>
                    })}
                </Space>
            }
        },
        {
            title: '未建立繳費單期',
            key: 'grade_class_data_not',
            dataIndex: 'grade_class_data',
            align: 'center',
            sorter: false,
            disabled: true,
            render: (text, record, index) => {
                let grade_class_data_first = text?.find(ele => true)
                let bill_payment_grade_class_data = grade_class_data_first?.bill_payment_grade_class_data
                bill_payment_grade_class_data = bill_payment_grade_class_data.filter(ele => ele.bill_payment_grade_class_Salary_TABLE_Formula_data.length === 0)
                let lastIndex = bill_payment_grade_class_data.length - 1
                return <Space direction="vertical">
                    {bill_payment_grade_class_data
                        .map((value, index2) => {
                            return (<Space>
                                <Button
                                    size='small'
                                    onClick={e => {
                                        if (value?.bill_payment_grade_class_id) {
                                            navigate(`/cramSchool/admin/AdminStudentTuition/${value?.bill_payment_grade_class_id}`)
                                        }
                                        else {
                                            message.error("無法前往")
                                        }
                                    }}
                                >
                                    {value?.year}第{value?.year_serial}期 ({value?.payment_time_start} ~ {value?.payment_time_end})
                                </Button>
                                {
                                    lastIndex === index2 &&
                                    <Popconfirm
                                        title="確定刪除此繳費單嗎？"
                                        onConfirm={() => { handleOnDeleteRow(value?.bill_payment_id) }}
                                    >
                                        < Button
                                            size='small'
                                            danger

                                        >
                                            刪除
                                        </Button >
                                    </Popconfirm>

                                }
                            </Space>)
                        })}
                </Space >
            }
        },
        {
            title: '繳費單',
            key: 'grade_class_data',
            dataIndex: 'grade_class_data',
            align: 'center',
            sorter: false,
            disabled: true,
            render: (text, record, index) => {
                let grade_class_data_first = text?.find(ele => true)
                let bill_payment_grade_class_data = grade_class_data_first?.bill_payment_grade_class_data
                return <Space direction="vertical">
                    {bill_payment_grade_class_data
                        .filter(ele => ele.bill_payment_grade_class_Salary_TABLE_Formula_data.length > 0)
                        .map((value, index2) => {

                            return <Button
                                type='primary'
                                onClick={e => {
                                    if (value?.bill_payment_grade_class_id) {
                                        navigate(`/cramSchool/admin/AdminStudentTuition/${value?.bill_payment_grade_class_id}`)
                                    }
                                    else {
                                        message.error("無法前往")
                                    }
                                }}
                                size='small'
                            >
                                {value?.year}第{value?.year_serial}期 ({value?.payment_time_start} ~ {value?.payment_time_end})
                            </Button>
                        })}
                </Space>
            }
        },
        {
            title: '操作',
            align: 'center',
            sorter: false,
            key: "option",
            dataIndex: 'grade_class_data',
            disabled: true,
            render: (text, record, index) => {
                let grade_class_data_first = text?.find(ele => true)
                let bill_payment_grade_class_data = grade_class_data_first?.bill_payment_grade_class_data
                let bill_payment_grade_class_data_not_grade_class = bill_payment_grade_class_data.filter(ele => ele.bill_payment_grade_class_Salary_TABLE_Formula_data.length === 0)
                let first_data = bill_payment_grade_class_data_not_grade_class.find(ele => true)
                return <>
                    <Button
                        style={{ marginRight: '1.5rem' }}
                        type="primary"
                        onClick={e => {
                            if (first_data?.bill_payment_grade_class_id) {
                                navigate(`/cramSchool/admin/AdminStudentTuition/${first_data?.bill_payment_grade_class_id}`)
                            }
                            else {
                                message.error("請建立新的繳費期")
                            }
                        }}
                    // onClick={() => {

                    //     handleAddTuition(record)
                    // }}
                    >建立班級繳費項目
                    </Button>
                    <Button
                        type="primary"
                        onClick={e => {
                            setClassId(record.class_id)
                            setAxiosMode('post')
                            setModalOpen(true)
                        }}
                    >
                        新增班級繳費期
                    </Button>
                </>
            }

        },
    ]);
    const [form] = Form.useForm();
    const [modalOpen, setModalOpen] = useState(false)
    // ================================================================
    const [classId, setClassId] = useState(null)
    // ================================================================


    const [modalLoading, setModalLoading] = useState(false)

    const [axiosMode, setAxiosMode] = useState("get")
    const [tuitionValues, setTuitionValues] = useState(null)
    const [year, setYear] = useState(null)
    const get_datas = (param, sort, filter, checklist) => {
        getBillPaymentClassData({
            cur_page: param?.current,
            size: param?.pageSize,
            year: year,
            custom_filter_key: checklist,
            custom_filter_value: param?.keyword,
        })
    }
    const reload = () => {
        set_force_reload(prev => prev + 1)
    }

    const handleAddTuition = (record) => {
        setColor('d65b77');
        setEdit(false);
        setEditCard({});
        setOpen(true);
        form.resetFields()
        let grade_class_data = record?.grade_class_data ?? []
        let grade_class_first_data = grade_class_data.find((element) => { return true })
        let grade_class_id = grade_class_first_data?.grade_class_id
        let lesson_class_data = record?.lesson_class_data ?? []
        let lesson_class_data_first = lesson_class_data.find(ele => true)
        setTuitionValues({
            ...record,
            ...lesson_class_data_first,
            grade_class_id: grade_class_id
        })
    }
    const handleOnAddRow = () => {
        setTitle('新增種類');
        setColor('d65b77');
        setEdit(false);
        setOpen(true);
        setEditCard({});
        form.resetFields()
    }
    const handleOnDeleteRow = (bill_payment_id) => {
        let data = []
        if (bill_payment_id) {
            data = [{
                bill_payment_id: bill_payment_id
            }]
        }
        else {
            if (selectedRowKeys.length === 0) {
                messageApi.open({
                    type: 'error',
                    content: '請選擇資料',
                });
            }
            else {
                data = selectedRowKeys.map((value) => {
                    return {
                        bill_payment_id: value
                    }
                })
            }
        }
        if (data.length > 0) {
            axios
                .delete(`/cramSchool/api/bill_payment_grade_class`,
                    {
                        data
                    }
                )
                .then((response) => {
                    if (response.data.status === 'success') {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '刪除成功',
                        });
                        reload()
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '刪除失敗',
                        });
                        reload()
                    }
                })
        }

    }
    const handleEdit = (values) => {
        if (values?.iFormulaID === undefined) {
            values.iFormulaID = 1
        }
        if (values?.iSerialID === undefined) {
            values.iSerialID = '';
        }
        let lesson_salary_table_formula = values?.lesson_id.map((value) => {
            return {
                "amount": 1,
                "lesson_id": value,
                "last_edit_user": 215
            }
        })
        let data = {
            "cSaveType": "edit",
            "aData": [
                {
                    "iFormulaID": values.iFormulaID,
                    "cName": values?.cName,
                    "iSign": '1',
                    "iFormulaType": values?.iFormulaType,
                    "tRemark": values?.tRemark,
                    "FormulaRule_data": [
                        {
                            "iRuleID": values?.iRuleID,
                            "cOperator": "*",
                            "fNumeric": values?.fNumeric,
                        }],
                    lesson_salary_table_formula: lesson_salary_table_formula

                }

            ]
        }
        axios
            .post(`/Salary/formula/dataSave`,
                data
            )
            .then((response) => {
                if (response.data.status === 'failed') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    reload();
                }
            })
    }
    const handleSubmit = (values) => {
        if (values.iFormulaID === undefined) {
            values.iFormulaID = 0
        }
        let lesson_Salary_TABLE_Formula = values?.lesson_id.map((value) => {
            return {
                "amount": 1,
                "lesson_id": value,
                "last_edit_user": 215
            }
        })

        let data = {
            "cSaveType": "new",
            "aData": [
                {
                    "iFormulaID": 0,
                    "cName": values?.cName,
                    "iSign": '1',
                    "iFormulaType": values?.iFormulaType,
                    "tRemark": values?.tRemark,
                    "FormulaRule_data": [
                        {
                            "iRuleID": values?.iRuleID,
                            "cOperator": "*",
                            "fNumeric": values?.fNumeric,
                        }],
                    lesson_Salary_TABLE_Formula: lesson_Salary_TABLE_Formula
                }
            ]

        }
        axios
            .post(`/Salary/formula/dataSave`,
                data
            )
            .then((response) => {
                if (response.data.status === 'failed') {
                    messageApi.open({
                        type: 'error',
                        content: '新增失敗 代碼編號記得不能填相同！',
                    });
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '新增成功',
                    });
                    reload();
                }
            })
            .finally(() => {

            })

    }
    const handleAddRow = () => {
        setClassId(null)
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }
    const onFormFinish = (values) => {
        let class_datas = values?.class_data ?? []
        let data = []
        class_datas.forEach(class_data => {
            let class_data_datas = class_data?.data
            class_data_datas.forEach((class_data_data) => {
                let payment_time = class_data_data?.payment_time
                let payment_time_start = dayjs(payment_time[0]).format("YYYY-MM-DD")
                let payment_time_end = dayjs(payment_time[1]).format("YYYY-MM-DD")
                data.push({
                    payment_time_start,
                    payment_time_end,
                    "grade_class_id": class_data?.grade_class_id,
                    "year": values?.year,
                    "year_serial": class_data_data?.year_serial,
                    default_class_count: class_data?.default_class_count,
                    class_id: class_data?.class_id,
                })
            })
        })
        postBillPaymentClassData(data)
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                reload()
            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                reload()
            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                reload()
                setSelectedRowKeys([])
                // setSelectedRowsInfo([])
            }
            else if (axiosMode === "get") {
                set_total(values.total)
                setDatas(values.data);
                set_loading(false)
            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                reload()
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                reload()
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                reload()
            }
            setModalLoading(false)
            setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }
    const {
        getBillPaymentClassData,
        postBillPaymentClassData,
    } = useBillPaymentClass({
        onBefore: () => { },
        onFinish: onFinish
    })
    useEffect(() => {
        reload()
    }, [year])
    useEffect(() => {
        get_datas()
    }, []);
    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                {contextHolder}
            </Col>
            <Col span={24}>
                {/* <AddTuitionModal
                    defaultValue={tuitionValues}
                    open={open}
                    setOpen={setOpen}
                    editcard={editcard}
                    setEditCard={setEditCard}
                    color={color}
                /> */}
                <BillPaymentClassModal
                    classId={classId}
                    setClassId={setClassId}
                    axiosMode={axiosMode}
                    propsOpen={modalOpen}
                    propsSetOpen={setModalOpen}
                    propsForm={form}
                    propsLoading={modalLoading}
                    propsSetLoading={setModalLoading}
                    onFinish={onFormFinish}
                />
                <Row gutter={[8, 16]}>
                    <Col span={24}>
                        <NewTable
                            force_reset={force_reset}
                            handleSearchYear={(string) => { setYear(string === "" ? null : string) }}
                            searchYear={true}
                            total={total}
                            extra_columns={extra_columns}
                            set_extra_columns={set_extra_columns}
                            loading={loading}
                            page_name={'AdminLessonTuitionOverview'}
                            force_reload={force_reload}
                            columns={default_column.concat(extra_columns || [])}
                            getData={get_datas}
                            datas={datas}
                            other={false}
                            add_button_title={'新增繳費期'}//新增按鈕上的名稱
                            handleOnAddRow={handleAddRow}//新增row 內容
                            rowkey={'class_id'}//key
                            setSelectedRowKeys={setSelectedRowKeys}
                            selectedRowKeys={selectedRowKeys}
                            handleOnDeleteRow={handleOnDeleteRow}//多筆刪除
                            delete={false}
                        ></NewTable>
                    </Col>
                </Row>
            </Col>

        </Row>
    )
}
export default BillPaymentClassOverview;